let isUpdated35Layout = false;
const initializeBodyObservationFor35 = () => {
  const targetNode = document.body;
  const config = { attributes: true };
  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        onBodyClassChange35();
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}
function onBodyClassChange35(newClass) {
  console.log('Body class changed:', newClass);
  // Your logic when the body class changes
  updateAB035Content();
  
}
jQuery(document).ready(function() {
  let previousClass = $('body').attr('class');
  if($("body.template-product").length > 0 && theme.settings.productTemplate35 == 'pads' && theme.settings.hwabt35 == 'test'){
    /*setInterval(function() {
      let currentClass = $('body').attr('class');
      if (currentClass !== previousClass) {
        previousClass = currentClass;
        onBodyClassChange35(currentClass);
      }
    }, 500);*/ // Check every 500 milliseconds. Adjust the interval as needed.
    initializeBodyObservationFor35();
  }
  

  
   if (theme.settings.hwabt35 == 'v1' && theme.settings.productTemplate35 == 'pads') {
    if(document.querySelectorAll(`.custom-swatches-new .custom-swatch[data-last="false"]`).length > 0){
      updateAB035VarinatOrder();
    }
   }
});

const updateAB035Content = ()=>{
  if(document.body.classList.contains("hw-abt-35-1") && isUpdated35Layout == false){
    isUpdated35Layout = true;
    updateAB035VarinatOrder();
  }else{
    /*if(isUpdated35Layout == true){
      updateAB035VarinatOrder();
      isUpdated35Layout = false;
    }*/
  }
}

const updateAB035VarinatOrder = () => {
   if (theme.settings.hwabt35 !== 'v0' && theme.settings.productTemplate35 == 'pads') {
    if(document.querySelectorAll(`.custom-swatches-new .custom-swatch[data-last="false"]`).length > 0){
       if(document.body.classList.contains("hw-abt-35-1") || theme.settings.hwabt35 == 'v1'){
          document.querySelector(`.custom-swatches-new .custom-swatch[data-last="false"]`).style.flexDirection="row-reverse";
          document.querySelector(`.custom-swatches-new .custom-swatch[data-last="false"]`).style.justifyContent="flex-end";
         setTimeout(function(){
           
           const targetInput = document.querySelector(`.custom-swatches-new .custom-swatch[data-last="false"] .custom-swatch-element:not(.checked-item) input`);
            if (targetInput) {
                targetInput.checked = true;
                const event = new Event('change', {
                    bubbles: true,
                    cancelable: true
                });
                targetInput.dispatchEvent(event);
            }
         },300)
       }else{
         document.querySelector(`.custom-swatches-new .custom-swatch[data-last="false"]`).removeAttribute("style");
       }
    }
   }
}